import { gsap } from '../global/gsap';

const initHomeWork = (section) => {
    const cta = section.querySelector('.js-home-work-btn');

    if (!cta) return;

    const mm = gsap.matchMedia();

    mm.add(
        { isDesktop: '(min-width: 900px)', isMobile: '(max-width: 899px)' },
        (context) => {
            const { isDesktop } = context.conditions;

            gsap.to(section, {
                scrollTrigger: {
                    trigger: section,
                    start: isDesktop ? 'top top' : 'top center',
                    end: isDesktop ? 'bottom 10%' : 'bottom bottom',
                    toggleClass: {
                        targets: cta,
                        className: 'is-active',
                    }
                },
            });
        },
    );
};

export default initHomeWork;
